const ROOT = "collapsibleListComponent";
const NEW_PAIR_BUTTON = "CollapsibleListNewPair_button";
const COLLAPSIBLE_LIST_ITEM = "collapsibleListItem";
const COLLAPSIBLE_LIST_ITEM_TITLE = "collapsibleListItemTitle";
const COLLAPSIBLE_LIST_ITEM_BODY = "collapsibleListItemBody";
const EXPAND_BUTTON = "collapsibleListExpandButton";
const TOOLBAR_DELETE_BUTTON = "blockButton_delete";
const MODAL_ROOT = "collapsibleListModal";
const COLLAPSIBLE_LIST_ONE_PAIR_EXPANDED = "onePairExpanded";
const COLLAPSIBLE_LIST_EXPANDED_DEFAULT = {
  ALL: "collapsibleListDefaultOptionExpanded",
  FIRST: "collapsibleListDefaultOptionFirstExpanded",
  NONE: "collapsibleListDefaultOptionCollapsed"
};
export {
  COLLAPSIBLE_LIST_EXPANDED_DEFAULT,
  COLLAPSIBLE_LIST_ITEM,
  COLLAPSIBLE_LIST_ITEM_BODY,
  COLLAPSIBLE_LIST_ITEM_TITLE,
  COLLAPSIBLE_LIST_ONE_PAIR_EXPANDED,
  EXPAND_BUTTON,
  MODAL_ROOT,
  NEW_PAIR_BUTTON,
  ROOT,
  TOOLBAR_DELETE_BUTTON
};
//# sourceMappingURL=dataHooks.js.map
